function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stringValue } from 'vega-util';
import { disableDirectManipulation, TUPLE } from '.';
import { varName } from '../../util';
import { assembleInit } from './assemble';
import nearest from './nearest';
import { TUPLE_FIELDS } from './project';
import { isLegendBinding } from '../../selection';
var inputBindings = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'point' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind !== 'scales' && !isLegendBinding(selCmpt.bind);
  },
  parse: function parse(model, selCmpt, selDef) {
    return disableDirectManipulation(selCmpt, selDef);
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var bind = selCmpt.bind;
    var init = selCmpt.init && selCmpt.init[0]; // Can only exist on single selections (one initial value).
    var datum = nearest.defined(selCmpt) ? '(item().isVoronoi ? datum.datum : datum)' : 'datum';
    proj.items.forEach(function (p, i) {
      var sgname = varName("".concat(name, "_").concat(p.field));
      var hasSignal = signals.filter(function (s) {
        return s.name === sgname;
      });
      if (!hasSignal.length) {
        var _ref, _bind$p$field;
        signals.unshift(_objectSpread(_objectSpread({
          name: sgname
        }, init ? {
          init: assembleInit(init[i])
        } : {
          value: null
        }), {}, {
          on: selCmpt.events ? [{
            events: selCmpt.events,
            update: "datum && item().mark.marktype !== 'group' ? ".concat(datum, "[").concat(stringValue(p.field), "] : null")
          }] : [],
          bind: (_ref = (_bind$p$field = bind[p.field]) !== null && _bind$p$field !== void 0 ? _bind$p$field : bind[p.channel]) !== null && _ref !== void 0 ? _ref : bind
        }));
      }
    });
    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var signal = _signals.find(function (s) {
      return s.name === name + TUPLE;
    });
    var fields = name + TUPLE_FIELDS;
    var values = proj.items.map(function (p) {
      return varName("".concat(name, "_").concat(p.field));
    });
    var valid = values.map(function (v) {
      return "".concat(v, " !== null");
    }).join(' && ');
    if (values.length) {
      signal.update = "".concat(valid, " ? {fields: ").concat(fields, ", values: [").concat(values.join(', '), "]} : null");
    }
    delete signal.value;
    delete signal.on;
    return _signals;
  }
};
export default inputBindings;